var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAboutSectionJourneyVertical(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 7,
    height: 52,
    viewBox: "0 0 7 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.5 46.3333C2.02724 46.3333 0.833331 47.5272 0.833331 49C0.833331 50.4728 2.02724 51.6667 3.5 51.6667C4.97276 51.6667 6.16666 50.4728 6.16666 49C6.16666 47.5272 4.97276 46.3333 3.5 46.3333ZM3 -2.18557e-08L3 49L4 49L4 2.18557e-08L3 -2.18557e-08Z",
    fill: "#828282"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAboutSectionJourneyVertical);
export default __webpack_public_path__ + "static/media/about_section_journey_vertical.8adf4e305ad4c481a01767c57039d57e.svg";
export { ForwardRef as ReactComponent };